import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=e29665b6&scoped=true&lang=html"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29665b6",
  null
  
)

export default component.exports